<template>
    <console-content v-if="ready" max-width="1024">

        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="tit tit--lg">
                <span v-if="product._id">상품상세</span>
                <span v-else>상품등록</span>
            </v-col>
            <v-spacer/>
        </v-row>

        <v-card class="mx-1 mt-4">
            <v-card-title class="pb-2">
                <span class="tit tit--xs"><b>카테고리</b></span>
                <v-spacer/>
                <v-btn color="primary" small @click="product._categories.push(null)"><v-icon small class="mr-2">mdi-plus</v-icon> 카테고리 추가</v-btn>
            </v-card-title>
            <v-card-text>
                <v-layout v-for="_category, index in product._categories" :key="index" align-end :class="{ 'mt-4': index ? true : false }">
                    <category-select v-model="product._categories[index]" :disabled="!$hasScope(['root', 'admin'])" :categories="categories" :allowDepth="[1, 2]"/>
                    <v-btn v-if="1 < product._categories.length" small text icon class="ml-2" @click="product._categories.splice(index, 1)"><v-icon size="20">mdi-delete</v-icon></v-btn>
                </v-layout>
            </v-card-text>
        </v-card>

        <v-row class="mt-4">
            <v-col cols="12" md="7" class="pr-md-1">
                <v-card class="mx-1">
                    <v-card-title class="tit tit--xs font-weight-bold">썸네일</v-card-title>
                    <v-card-text>
                        <v-layout no-gutters align-center>
                            <v-img v-if="thumb" :src="thumb" max-width="96" height="auto" contain></v-img>
                            <v-sheet v-else width="96" height="96" color="d-flex justify-center align-center grey lighten-2"><v-icon>mdi-image</v-icon></v-sheet>
                            <v-file-input v-model="product.thumb" :disabled="!$hasScope(['root', 'admin'])" />
                        </v-layout>
                    </v-card-text>
                </v-card>

                <v-card class="mx-1 mt-3">
                    <v-card-title>
                        <span class="tit tit--xs"><b>이미지</b></span>
                        <v-spacer/>
                        <v-btn v-if="product.images.length > 1" :disabled="!$hasScope(['root', 'admin'])" color="primary" small @click="product.images.pop()"><v-icon small class="mr-2">mdi-minus</v-icon>이미지삭제</v-btn>
                        <v-btn v-if="product.images.length < 6" :disabled="!$hasScope(['root', 'admin'])" color="primary" small @click="product.images.push(null)"><v-icon small class="mr-2">mdi-plus</v-icon>이미지추가</v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-draggable v-model="product.images">
                            <v-layout v-for="(image, index) in product.images" :key="index" no-gutters align-center class="mb-4">
                                <v-img v-if="images[index]" :src="images[index]" max-width="96" height="auto" contain></v-img>
                                <v-sheet v-else width="96" height="96" color="d-flex justify-center align-center grey lighten-2"><v-icon>mdi-image</v-icon></v-sheet>
                                <v-file-input v-model="product.images[index]" :disabled="!$hasScope(['root', 'admin'])" />
                            </v-layout>
                        </v-draggable>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="5" class="pl-md-1">
                <v-card class="mx-1 mt-3 mt-md-0">
                    <v-card-title>
                        <span class="tit tit--xs"><b>기본정보</b></span>
                    </v-card-title>
                    <v-card-text>
                        <v-text-field v-model="product.name" label="상품이름" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details="" />
                        <v-text-field v-show="product._id" v-model="product.code" label="상품코드" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details="" class="mt-4" />
                        <v-text-field v-model="product.no" label="진열순서" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details="" class="mt-4" />
                        <v-text-field v-model="product.writer" label="작가" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details="" class="mt-4"/>
                        <v-text-field v-model="product.publisher" label="출판사" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details="" class="mt-4" />
                        <v-text-field v-model="product.costPrice" label="소비자가" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details="" class="mt-4" />
                        <v-text-field v-model="product.salePrice" label="판매가" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details="" class="mt-4" />
                        <v-text-field v-model="product.stock" label="재고" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details="" class="mt-4" />
                    </v-card-text>
                </v-card>

                <v-card class="mx-1 mt-4">
                    <v-card-title class="align-center">
                        <span class="tit tit--xs"><b>상품정보</b></span>
                        <v-spacer/>
                        <v-switch v-model="shoppingEnabled" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                    </v-card-title>
                        <v-card-text v-show="shoppingEnabled" class="mx-1 mt-3 mt-md-0">
                            <v-col style="display: flex" v-for="item, index in product.info" :key="index">
                                <v-text-field v-model="item.name" label="상품가격" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details="" />
                                <v-text-field v-model="item.value" label="1,000 (예시)" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details="" />
                            </v-col>
                            <v-layout class="mt-2 mx-n1">
                                <v-flex xs2 class="px-1">
                                    <v-btn :disabled="!$hasScope(['root', 'admin'])" width="36" color="primary" class="px-1" style="min-width: auto" @click="decrease"><v-icon>mdi-minus</v-icon></v-btn>
                                </v-flex>
                                <v-flex xs2 class="px-1">
                                    <v-btn :disabled="!$hasScope(['root', 'admin'])" width="36" color="primary" class="px-1" style="min-width: auto" @click="increase"><v-icon>mdi-plus</v-icon></v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                </v-card>

                <v-card class="mx-1 mt-4">
                    <v-card-title class="align-center">
                        <span class="tit tit--xs"><b>품절여부 (판매 / 품절)</b></span>
                        <v-spacer/>
                        <v-switch v-model="product.soldout" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                    </v-card-title>
                    <v-divider/>
                    <v-card-title class="align-center">
                        <span class="tit tit--xs"><b>진열여부 (진열안함 / 진열)</b></span>
                        <v-spacer/>
                        <v-switch v-model="product.onDisplay" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                    </v-card-title>
                </v-card>

                <v-card class="mx-1 mt-4">
                    <v-card-title class="align-center">
                        <span class="tit tit--xs"><b>공제분류 (일반상품 / 도서·문화상품)</b></span>
                        <v-spacer/>
                        <v-switch v-model="product.isDeduction" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                    </v-card-title>
                </v-card>

                <v-card class="mx-1 mt-4">
                    <v-card-title class="align-center">
                        <span class="tit tit--xs"><b>베스트</b></span>
                        <v-spacer/>
                        <v-switch v-model="product.isBest" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                    </v-card-title>
                    <v-divider/>
                    <v-card-title class="align-center">
                        <span class="tit tit--xs"><b>메인진열</b></span>
                        <v-spacer/>
                        <v-switch v-model="product.isMain" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                    </v-card-title>
                    <v-divider/>
                    <v-card-title class="align-center">
                        <span class="tit tit--xs"><b>추천</b></span>
                        <v-spacer/>
                        <v-switch v-model="product.isRecommend" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                    </v-card-title>
                    <v-divider/>
                    <v-card-title class="align-center">
                        <span class="tit tit--xs"><b>신상품</b></span>
                        <v-spacer/>
                        <v-switch v-model="product.isNewly" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                    </v-card-title>
                    <v-divider/>
                    <v-card-title class="align-center">
                        <span class="tit tit--xs"><b>인기</b></span>
                        <v-spacer/>
                        <v-switch v-model="product.isPopular" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0"/>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>

        <!-- <v-card class="mt-4 mx-1">
            <v-card-title>
                <v-layout align-center>
                    <v-flex class="tit tit--xs font-weight-bold">포인트 정책</v-flex>
                    <v-spacer/>
                    <v-flex grow-shrink-0>
                        <v-text-field v-model="product.pointPercent" label="포인트 적립률" dense outlined hide-details suffix="%" />
                    </v-flex>
                </v-layout>
            </v-card-title>
        </v-card> -->

        <v-card class="mt-4 mx-1">
            <v-card-title class="tit tit--xs font-weight-bold pb-2">
                <v-layout wrap align-center>
                    <span>옵션상품</span>
                    <v-spacer/>
                    <v-switch v-model="optionalEnabled" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mb-1 mt-0 pt-0" />
                </v-layout>
            </v-card-title>

            <v-divider/>

            <optional-products v-show="optionalEnabled" v-model="product.optionalProducts" :salePrice='product.salePrice'/>
        </v-card>

        <v-card v-show="false" class="mt-4 mx-1">
            <v-card-title class="tit tit--xs font-weight-bold pb-2">
                <v-layout wrap align-center>
                    <span>추가상품</span>
                    <v-spacer/>
                    <v-switch v-model="additionalEnabled" hide-details class="mb-1 mt-0 pt-0" />
                </v-layout>
            </v-card-title>

            <v-divider/>

            <additional-products v-show="additionalEnabled" v-model="product.additionalProducts" />
        </v-card>

        <v-card class="mt-4 mx-1">
            <v-card-title class="tit tit--xs font-weight-bold pb-2">
                <v-layout wrap align-center>
                    <span>ebook 상품</span>
                    <v-spacer/>
                    <v-switch v-model="ebookEnabled" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mb-1 mt-0 pt-0" />
                </v-layout>
            </v-card-title>

            <v-divider/>

            <ebook-products v-show="ebookEnabled" v-model="product.ebookProducts" :salePrice='product.salePrice' :enabled="ebookEnabled" :_ebookCompany.sync="product._ebookCompany" />
        </v-card>

        <v-card class="mt-4 mx-1">
            <v-card-title class="tit tit--xs font-weight-bold pb-2">배송정책</v-card-title>
            <v-card-text>
                <v-radio-group v-model="product.shippingCode" :disabled="!$hasScope(['root', 'admin'])" row dense hide-details class="pa-0 ma-0">
                    <v-layout align-center wrap>
                        <v-flex grow-shrink-0>
                            <v-radio label="기본 배송정책" value="order" />
                        </v-flex>
                        <v-flex grow-shrink-0>
                            <v-radio label="무료배송" value="free" />
                        </v-flex>
                        <v-flex grow-shrink-0>
                            <v-radio label="수신자 부담(착불)" value="later" />
                        </v-flex>
                        <v-flex grow-shrink-0>
                            <v-layout align-center>
                                <v-radio label="구매상품별" value="self" />
                                <v-responsive max-width="200" class="pa-0 mr-2">
                                    <v-text-field v-model="product.shippingPrice" outlined dense hide-details full-width suffix="원" class="pa-0 ma-0" :disabled="product.shippingCode != 'self'"/>
                                </v-responsive>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-radio-group>
            </v-card-text>
        </v-card>

        <v-card class="mt-4 mx-1">
            <v-card-title class="tit tit--xs font-weight-bold">상세정보</v-card-title>
            <v-card-text>
                <naver-smarteditor v-model="product.content" />
            </v-card-text>
        </v-card>

        <v-card class="mt-4 mx-1">
            <v-card-title class="tit tit--xs font-weight-bold">모바일</v-card-title>
            <v-card-text>
                <naver-smarteditor v-model="product.mobileContent" />
            </v-card-text>
        </v-card>

        <v-row class="my-6">
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn :disabled="!$hasScope(['root', 'admin'])" color="primary" @click="save">저장</v-btn>
            </v-col>
            <v-col cols="auto" class="py-0">
                <v-btn color="primary" @click="dialog = true">미리보기</v-btn>
            </v-col>
            <v-spacer/>
        </v-row>

        <v-dialog v-model="dialog" width="1200">
            <product-preview v-model="product"/>
        </v-dialog>
    </console-content>
</template>

<script>
import api from "@/api";
import ConsoleContent from "@/templates/console/ConsoleContent.vue";
import CategorySelect from "@/components/console/shop/categories/category-select.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
import OptionalProducts from "@/components/console/shop/products/optional-products.vue";
import AdditionalProducts from "@/components/console/shop/products/additional-products.vue";
import EbookProducts from "@/components/console/shop/products/ebook-products.vue";
import VDraggable from "vuedraggable";
import ProductPreview from "@/pages/console/shop/product/ProductPreview.vue"
export default {
    components: {
        CategorySelect,
        ConsoleContent,
        NaverSmarteditor,
        OptionalProducts,
        AdditionalProducts,
        EbookProducts,
        VDraggable,
        ProductPreview,
    },
    data(){
        return {
            dialog: false,
            ready: false,

            product: {
                _id: this.$route.params._product,
                _categories: [null],

                no: 0,
                name: null,
                code: null,
                type: "main",

                costPrice: 0,
                salePrice: 0,
                stock: 0,
                soldout: false,

                isBest: false,
                isRecommend: false,
                isNewly: false,
                isDeduction: false,
                isPopular: false,
                isMain: false,

                thumb: null,
                images: [],

                shippingCode: "self",
                shippingPrice: 0,

                pointPercent: 0,

                content: null,
                mobileContent: null,
                // 추가정보
                ...{
                    writer: null,
                    publisher: null,
                },
                // 쇼핑상품정보
                info: [{ name: '', value: '' }],
                
                optionalEnabled: [],
                additionalProducts: [],
                ebookProducts: [],

                onSale: true,
                onDisplay: true,
            },

            shoppingEnabled: false,
            optionalEnabled: false,
            additionalEnabled: false,
            ebookEnabled: false,

            categories: [],

            setting: null,
            infoCount: 1
        }
    },
    async mounted(){
        await this.init();
    },
    methods: {
        async init(){
            // 운영정보설정 조회
            let { setting } = await api.console.shop.setting.get();
            this.setting = setting;
            // 기본설정값
            this.product.shippingCode = setting.shippingCode || "self";
            this.product.pointPercent = setting.pointPercent.product || 0;

            // 카테고리 조회
            let { categories } = await api.console.shop.categories.gets({ params: { depth: 1 }});
            this.categories = categories;

            let { summary } = await api.console.shop.products.summary();
            this.product.no = summary.totalCount + 1;

            if(this.product._id){
                let { product } = await api.console.shop.products.get(this.product);
                // if(product.thumb) {
                //     product.thumb = await api.getResource(product.thumb);
                // }
                // for(let index in product.images){
                //     try{
                //         if(product.images[index]) product.images[index] = await api.getResource(product.images[index]);
                //     }
                //     catch(error){
                //         console.log(error);
                //     }
                // }
                this.shoppingEnabled = !!product?.info?.length;
                this.optionalEnabled = !!product?.optionalProducts?.length;
                this.additionalEnabled = !!product?.additionalProducts?.length;
                this.ebookEnabled = !!product?.ebookProducts?.length;
                this.product = product;
            }

            this.ready = true;
        },

        validate(){
            try{
                if (!this.product.costPrice) throw new Error("소비자가를 입력해주세요")
                if (!this.product.salePrice) throw new Error("판매가를 입력해주세요")
                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },
        async save(){
            if (this.validate()) {
                if(this.product.stock) this.product.soldout = false
                this.product.stock = this.product.optionalProducts?.reduce((stock, optionalProduct) => !optionalProduct.isDeleted ? +optionalProduct.stock + stock : stock, 0) || this.product.stock;

                let { product } = this.product._id ? await api.console.shop.products.put({ ...this.product, thumb: undefined, images: undefined }) : await api.console.shop.products.post({ ...this.product, thumb: undefined, images: undefined });

                if(this.thumb){
                    let { thumb } = await api.console.shop.products.thumb.post(product._id, this.product.thumb);
                    product.thumb = thumb;
                }

                for(let index in this.images){
                    if(this.images[index]){
                        let { images } = await api.console.shop.products.images.post(product._id, index, this.product.images[index]);
                        product.images = images;
                    }
                }

                // 옵션상품 저장로직
                for(let optionalProduct of this.product.optionalProducts || []){
                    if(!this.optionalEnabled || optionalProduct.isDeleted) await api.console.shop.products.delete(optionalProduct);
                    else optionalProduct?._id ? await api.console.shop.products.put({ ...product, _mainProduct: product._id, ...optionalProduct }) : await api.console.shop.products.post({ ...product, _id: null, _mainProduct: product._id, ...optionalProduct });
                }

                // 추가상품 저장로직
                for(let additionalProduct of this.product.additionalProducts || []){
                    if(!this.additionalEnabled || additionalProduct.isDeleted) await api.console.shop.products.delete(additionalProduct);
                    else additionalProduct?._id ? await api.console.shop.products.put({ ...product, _mainProduct: product._id, ...additionalProduct }) : await api.console.shop.products.post({ ...product, _id: null, _mainProduct: product._id, ...additionalProduct });
                }

                // ebook 상품 저장로직
                for(let ebookProduct of this.product.ebookProducts || []){
                    if(!this.ebookEnabled || ebookProduct.isDeleted) await api.console.shop.products.delete(ebookProduct);
                    else ebookProduct?._id ? await api.console.shop.products.put({ ...product, _mainProduct: product._id, ...ebookProduct  }) : await api.console.shop.products.post({ ...product, _id: null, _mainProduct: product._id, ...ebookProduct });
                }

                alert("저장되었습니다");
                this.$router.go(-1);
            }
        },
        increase(){
            this.product.info.push({ name: "", value: "" })
        },
        decrease(){
            this.product.info.pop()
        }
    },
    computed: {
        thumb(){
            try{
                return URL.createObjectURL(this.product.thumb);
            }
            catch(error){
                return null;
            }
        },
        images(){
            let images = new Array(this.product.images.length);
            for(var i in this.product.images){
                try{
                    images[i] = URL.createObjectURL(this.product.images[i]);
                }
                catch(error){}
            }
            return images;
        },
        tests(){
            return [
                { message: 1 },
                { message: 2 },
                { message: 3 },
                { message: 4 },
                { message: 5 },
            ];
        },
        totalStock(){
            return this.product?.optionalProducts?.reduce((total,{stock})=> total + (+stock || 0), 0)
        },
    },
    watch: {
        'product.shippingCode'(){
            if(this.product.shippingCode === 'order' || this.product.shippingCode === 'free' || this.product.shippingCode === 'later'){

                this.product.shippingPrice = 0

                if (this.optionalEnabled) { // 옵션상품이 있을 때
                    this.product.optionalProducts.forEach((el) => {
                        el.shippingCode = this.product.shippingCode
                    })
                }
                return
            }
            if(this.optionalEnabled) {
                this.product.optionalProducts.forEach((el) => {
                    el.shippingCode = this.product.shippingCode
                    el.shippingPrice = this.product.shippingPrice
                })
            }
        },
        "totalStock"() {
            if(this.optionalEnabled) this.product.stock = this.totalStock
        },
        "product.shippingPrice"() {
            if(this.optionalEnabled) {
                this.product.optionalProducts.forEach((el) => {
                    el.shippingPrice = this.product.shippingPrice
                })
            }
        },
        "product.isDeduction"() {
            if(this.optionalEnabled) {
                this.product.optionalProducts.forEach((el) => {
                    el.isDeduction = this.product.isDeduction
                })
            }
        },
        "product.salePrice"() {
            if (this.ebookEnabled) {
                this.product.ebookProducts[0].salePrice = this.product.salePrice
            }
        }
    }
}
</script>